import { Directive, OnInit, OnDestroy, Injectable, Inject, forwardRef, Input } from '@angular/core';
import { DataBindingDirective, GridComponent } from '@progress/kendo-angular-grid';
import { Subscription } from 'rxjs';
import {  ArtikelpreisVkDataService } from '../data-services';
import { ODataBindingDirective } from './core/o-data-binding-directive';
import { ODataEntitySetResource } from 'angular-odata';

@Injectable()
@Directive({
  selector: '[artikelpreisVkDataBinding]'
})
export class ArtikelpreisVkDataDirective  extends ODataBindingDirective  {

  @Input('artikelpreisVkDataBinding') query:  ODataEntitySetResource<any>;
    
    constructor(@Inject(forwardRef(() =>ArtikelpreisVkDataService)) dataService: ArtikelpreisVkDataService, @Inject(forwardRef(() => GridComponent))  grid: GridComponent) {
        super(dataService,grid);
    }
    public ngOnChanges( c: any ) : void {
 
        console.log( "Base-Query:", this.query);
        this.rebind();
    }
}
